import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { ToggleSize } from '@design-system/components/molecules/toggle/entities/toggle.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
  ]
})
export class ToggleDsComponent {

  @Input() size = ToggleSize.RG;
  @Input() icon: Icon;
  @Input() isActive = false;
  @Input() isDisabled = false;

  @Output() toggleOnChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

}
